import './SMSTemplatePreview.scss';
import React from 'react';
import InfoIcon from '/src/assets/icons/info-icon.svg';
import type { TSMSPreviewData } from 'components/FlowBuilder/FlowSidePanels/types';
import SMSPhonePreview from 'components/FlowBuilder/FlowSidePanels/SMSSidePanel/SMSTemplatePreview/SMSPhonePreview';

const MAIN_CLASS = `sms-template-preview`;
const CLASSES = {
  WITHOUT_INFO: `${MAIN_CLASS}--without-info`,
  WITH_INFO: `${MAIN_CLASS}--with-info`,
  HEADER: `${MAIN_CLASS}__header`,
  PREVIEW_LABEL: `${MAIN_CLASS}__preview-label`,
  PREVIEW_DESC: `${MAIN_CLASS}__preview-desc`,
  INFO_LABEL: `${MAIN_CLASS}__info-label`,
  TEMPLATE_AREA: `${MAIN_CLASS}__template-area`,
  PREVIEW_AREA: `${MAIN_CLASS}__preview-area`,
  SELECT_TEMPLATE: `${MAIN_CLASS}__select-template`,
  BLUE_SPAN: `${MAIN_CLASS}__blue-span`,
};

interface SMSTemplatePreviewProps {
  previewData?: TSMSPreviewData | null;
  isLoading?: boolean;
  isTemplateError?: boolean;
}

function SMSTemplatePreview({ previewData, isLoading, isTemplateError }: SMSTemplatePreviewProps) {
  return (
    <div className={`${MAIN_CLASS} ${previewData ? CLASSES.WITH_INFO : CLASSES.WITHOUT_INFO}`}>
      <div className={CLASSES.HEADER}>
        <div className={CLASSES.PREVIEW_LABEL}>Preview</div>
        <div className={CLASSES.PREVIEW_DESC}>
          {previewData ? (
            <span>
              This is a simulated preview of what the SMS message will look like.{' '}
              <span className={CLASSES.BLUE_SPAN}>Blue text</span> in the preview are tags defined in the Twilio
              template.
            </span>
          ) : (
            <span>This is a preview of the template you created in Twilio</span>
          )}
        </div>
      </div>
      {previewData && (
        <div className={CLASSES.INFO_LABEL}>
          <img src={InfoIcon} alt="Information icon" />
          <span>This is only a simulated preview and may not be exactly what appears on the end device</span>
        </div>
      )}
      <div className={CLASSES.TEMPLATE_AREA}>
        {previewData ? (
          <div className={CLASSES.PREVIEW_AREA}>
            <SMSPhonePreview previewData={previewData} isLoading={isLoading} />
          </div>
        ) : isTemplateError ? (
          <span className={`${CLASSES.SELECT_TEMPLATE} ${CLASSES.SELECT_TEMPLATE}__centered`}>
            Preview unavailable as we were unable to fetch this template. Please reload the page or try again later.
          </span>
        ) : (
          <span className={`${CLASSES.SELECT_TEMPLATE} ${CLASSES.SELECT_TEMPLATE}__centered`}>Select a template</span>
        )}
      </div>
    </div>
  );
}

export default SMSTemplatePreview;
